<app-supplier-catalogs
    [permissionKey]="'purchase.supplierCatalogs.list'"
    [supplierCatalogs]="element.SupplierCatalogs"
    (onPrepareRow)="onNewElement($event)"
    (beforeDelete)="onBeforeDelete($event)"
    (beforeAdd)="onBeforeInserting($event)"
    (beforeUpdate)="onBeforeUpdate($event)"
    (afterUpdate)="onAfterUpdate($event)"
></app-supplier-catalogs>